"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatOriginalCellValue = void 0;
const date_fns_1 = require("date-fns");
const formatOriginalCellValue = (value) => {
    // Format array values as comma-separated
    const formattedValue = Array.isArray(value) ? value.join(', ') : value;
    // Check if it's a strict ISO date and format it
    if (typeof formattedValue === 'string' && formattedValue) {
        const parsed = (0, date_fns_1.parseISO)(formattedValue);
        const isStrictDate = (0, date_fns_1.isValid)(parsed) && (0, date_fns_1.formatISO)(parsed) === formattedValue;
        return isStrictDate ? (0, date_fns_1.format)(parsed, 'MMM dd yyyy') : formattedValue;
    }
    return formattedValue || '';
};
exports.formatOriginalCellValue = formatOriginalCellValue;
